import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { FormField } from '@/components/forms';
import { getEventsGroupedByCategory } from '../../config/events';
import { EventCard } from '../EventCard';
import type { TriggerEventType } from '../../types';

interface EventStepProps {
  name: string;
  eventType: TriggerEventType | null;
  delay: number;
  onNameChange: (name: string) => void;
  onEventChange: (eventType: TriggerEventType) => void;
  onDelayChange: (delay: number) => void;
}

/**
 * EventStep
 * 
 * Шаг выбора события в wizard
 * 
 * @returns {React.ReactElement} React компонент
 */
export function EventStep({
  name,
  eventType,
  delay,
  onNameChange,
  onEventChange,
  onDelayChange,
}: EventStepProps) {
  const groups = getEventsGroupedByCategory();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Название триггера</CardTitle>
          <CardDescription>
            Укажите понятное название, чтобы легко находить триггер в списке
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <FormField label="Название" name="name" required>
            <Input
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="Приветствие нового пользователя"
              autoFocus
            />
          </FormField>

          <FormField
            label="Задержка выполнения"
            name="delay"
            hint="Сколько минут подождать перед выполнением действий (0 = сразу)"
          >
            <Input
              type="number"
              min={0}
              value={delay}
              onChange={(e) => onDelayChange(Number(e.target.value) || 0)}
              className="w-32"
            />
          </FormField>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Когда срабатывает триггер?</CardTitle>
          <CardDescription>Выберите событие, которое запустит триггер</CardDescription>
        </CardHeader>
        <CardContent className="space-y-8">
          {groups.map((group) => (
            <div key={group.category}>
              <h3 className="text-sm font-medium mb-3 flex items-center gap-2 text-muted-foreground">
                <group.icon className="h-4 w-4" />
                {group.label}
              </h3>
              <div className="grid gap-3 md:grid-cols-2">
                {group.events.map(({ key, config }) => (
                  <EventCard
                    key={key}
                    eventKey={key}
                    config={config}
                    selected={eventType === key}
                    onSelect={() => onEventChange(key)}
                  />
                ))}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
